/*
 * CandyPeak Spotlight
 * Version 1.0.0
 */

(function () {
  'use strict';

  var selector = [
    '.product-card-wrapper img',
    '.card-wrapper img',
    '.product-grid img',
    '[data-cp-spotlight]'
  ].join(',');

  function injectStyles() {
    if (document.getElementById('cp-spotlight-styles')) {
      return;
    }

    var style = document.createElement('style');

    style.id = 'cp-spotlight-styles';

    style.textContent = `
      .cp-spotlight-ready {
        transform: translate3d(0, 0, 0) scale(1);
        transform-origin: center center;
        will-change: transform, filter;
      }

      .cp-spotlight-active {
        animation:
          cp-product-spotlight
          620ms
          cubic-bezier(0.22, 1, 0.36, 1);
      }

      @keyframes cp-product-spotlight {
        0% {
          transform: translate3d(0, 0, 0) scale(1);
          filter: brightness(1);
        }

        45% {
          transform: translate3d(0, -4px, 0) scale(1.025);
          filter:
            brightness(1.035)
            drop-shadow(0 8px 14px rgba(255, 47, 146, 0.16));
        }

        100% {
          transform: translate3d(0, 0, 0) scale(1);
          filter: brightness(1);
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .cp-spotlight-active {
          animation: none !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function activateSpotlight(element) {
    if (
      !element ||
      element.dataset.cpSpotlightDone === 'true'
    ) {
      return;
    }

    element.dataset.cpSpotlightDone = 'true';
    element.classList.add('cp-spotlight-ready');

    window.setTimeout(function () {
      element.classList.add('cp-spotlight-active');

      window.setTimeout(function () {
        element.classList.remove('cp-spotlight-active');
      }, 700);
    }, 90);
  }

  function initSpotlight() {
    injectStyles();

    var elements = document.querySelectorAll(selector);

    if (!elements.length) {
      return;
    }

    if (
      !('IntersectionObserver' in window) ||
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
    ) {
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];

          if (!entry.isIntersecting) {
            continue;
          }

          activateSpotlight(entry.target);
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.75,
        rootMargin: '0px 0px -4% 0px'
      }
    );

    for (var i = 0; i < elements.length; i++) {
      observer.observe(elements[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initSpotlight
    );
  } else {
    initSpotlight();
  }
})();